export const init = () => {
    //console.log('Hero Video Init');
    const blocks = document.querySelectorAll('.hero-video-block');
    //console.log('Hero Video Blocks found:', blocks.length);
    
    blocks.forEach(block => {
        const video = block.querySelector('.hero-video-element');
        const btn = block.querySelector('.play-pause-btn');
        const btnText = btn ? btn.querySelector('.text') : null;
        
        if (!video || !btn) {
            console.warn('Hero Video: Missing elements', { video, btn });
            return;
        }
        
        const togglePlay = (e) => {
            e.preventDefault();
            //console.log('Play/Pause clicked', video.paused);
            if (video.paused) {
                video.play();
                block.classList.remove('is-paused');
                btn.setAttribute('aria-label', 'Pause Video');
            } else {
                video.pause();
                block.classList.add('is-paused');
                btn.setAttribute('aria-label', 'Play Video');
            }
        };

        btn.addEventListener('click', togglePlay);
    });
};
